<template>
  <div class="client-staff">
    <div class="client-search">
        <el-input class="base-msg-input" size="mini" v-model="formInline.ctmNameOrPhoneOrCtmCode" suffix-icon="el-icon-search" placeholder="客户姓名/卡号/手机号" @blur="onInputBlur" @clear="onInputBlur" clearable></el-input>
        <el-date-picker
          v-model="dateTime"
          size="mini"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="~"
          :editable="false"
          start-placeholder="添加日期"
          end-placeholder="添加日期"
          @change="selectTime"
          clearable
          style="width: 240px; margin-right: 10px"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
        <el-tag class="add-per-input" title="选择添加人"  :closable="this.searchMenNames.length===0?false:true" @close="searchCloseTag" type="medium" effect="plain" @click="clickAddMember(true)">
            <span v-if="searchMenNames.length===0">选择添加人</span>
            <span v-for="(item,index) in searchMenNames" :key="index">{{item.name}}<span v-if="searchMenNames.length>1">,</span></span>
        </el-tag>
        <el-cascader 
          v-model="tagsData" 
          placeholder="选择标签" 
          size="mini" 
          :options="options" 
          :props="props" 
          :show-all-levels="false" 
          clearable 
          collapse-tags 
          @blur="selectTags"
        ></el-cascader>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table
          size="small"
          :data="tableData"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(100vh - 235px)"
          ref="cusChatTable"
          style="font-size: 13px"
        >
          <!-- v-loading="loading"
          element-loading-text="拼命加载中" -->
          <el-table-column
            type="index"
            min-width="50">
          </el-table-column>
          <el-table-column prop="customerName" label="客户" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-row :gutter="20">
                <el-col :span="30" style="padding:0">
                  <el-avatar size="medium" shape="square" :src="scope.row.avatar"></el-avatar>
                </el-col>
                <el-col :span="70" >
                  <div v-if="scope.row.ctmName != null">{{scope.row.ctmName}}</div>
                  <div v-else>--</div>
                  <div style="color: #a09f9fc9; font-size: 12px;">
                    {{scope.row.name}}
                    <span style="color: rgb(70, 189, 10)" v-if="scope.row.type == 1 "> @微信</span>
                    <span style="color: rgb(8, 168, 231)" v-else > @企业微信</span>
                  </div>
                </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="添加时间"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="userName"
            label="添加人"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="usageScenario"
            label="客户标签"
            min-width="200"
          >
            <template slot-scope="scope">
                <div>
                    <el-tag
                        style="margin:5px 4px 0 0"
                        v-for="item in scope.row.tagIdList"
                        :key="item.tagId"
                        v-show="item.tagName!=null"
                        size="small"
                        >
                        {{item.tagName}}
                    </el-tag>
                </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="recentTime"
            label="最近跟进"
            min-width="120"
          ></el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <!-- 添加人员树 -->
    <!-- <AddMemberView 
      :title="title"
      :dialogVisibleTree="dialogVisibleTree" 
      :currentSelectMember='currentSelectMember' 
      @closeTree='closeTree' 
      @clickSubmitTree='clickSubmitTree'
    ></AddMemberView> -->
    <StaffTree title="添加成员" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree' ></StaffTree>
  </div>
</template>
<script>
import StaffTree from '@/components/staffTree/staffTree.vue'
import AddMemberView from "./components/addMember.vue";
import {getCustomer,activityTagType} from "@/api/activeCode/activeCode.js";

export default {
  name: "CusChatSupervise",
  components: {
    // AddMemberView,
    StaffTree
  },
  data() {
    return {
      title:"选择添加人",
      tableData: [],
      // loading: false,
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 20,
      },
      dateTime:"",
      //查询列表初始参数
      formInline: {
        ctmNameOrPhoneOrCtmCode:"", //姓名或者手机或者卡号
        userIdList:[],//成员userId集合
        tagIdList:[], //标签tagId集合
        startTime:null, //开始时间
        endTime:null,//结束时间
        pageNum: 1, //页码 默认1
        pageSize: 20,//每页条数  默认10
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      dialogVisibleTree:false, //添加人弹窗开关
      currentSelectMember:[], //组件中要显示-选中的成员
      searchMenNames:[], //当前 搜索框-选中的成员
      // markLength:0,
      // 客户管理
      props: { multiple: true },
      options: [],
      tagsData:[]
    };
  },
  created() {
    this.getCustomer()
    this.getActivityTagGroup()
  },
  watch:{
    // markLength(val){
    //   if(this.markLength == this.currentSelectMember.length){
    //     this.getCustomer()
    //   }
    // },
    tagsData(val){
      this.formInline.pageNum = 1
      this.formInline.tagIdList = [] 
      if(val.length !=0){
        val.map(v=>{
          this.formInline.tagIdList.push(
            v[1]
          )
        })
      }
      this.getCustomer()
    }
  },
  methods: {
    //获取标签组数据
    getActivityTagGroup(){
      activityTagType({pageNum: 1,pageSize: 1000 },localStorage.getItem("Authorization")).then((res)=>{
        if(res.error.code==200){
          let groupList = res.data.records
          groupList.map(v=>{
            let obj = {
              value: v.groupId,
              label: v.groupName,
              children:[]
            }
            if(v.hmcActivityTagList.length!=0){
              v.hmcActivityTagList.map(s=>{
                obj.children.push({
                  value: s.tagId,
                  label: s.tagName,
                })
              })
            }
            this.options.push(obj)
          })
        }
      }).catch((err)=>{})
    },
    //分页回调
    callBack(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getCustomer()
    },
    //获取客户列表
    getCustomer(){
      // this.loading = false;
      getCustomer(this.formInline,localStorage.getItem("Authorization")).then((res)=>{
        if(res.error.code==200){
          this.tableData = res.data.result
          this.pageparm.total = res.data.total
        }
      }).catch((err)=>{})
    },
    //选择时间
    selectTime(val){
      this.pageNum = 1
      if(val == null){
        this.formInline.startTime = null
        this.formInline.endTime =  null
      }else{
        this.formInline.startTime = val[0]
        this.formInline.endTime =  val[1]
      }
      this.getCustomer()
    },
    //客户姓名、卡号、手机号 输入框失焦
    onInputBlur(){
      this.pageNum = 1
      this.getCustomer()
    },
    //打开添加人弹窗回调
    clickAddMember(){
      this.dialogVisibleTree = true;
    },
    //关闭添加人弹窗回调
    closeTree(val){
      this.dialogVisibleTree = false;
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
        var obj = {};
        const arrays = Arr.reduce((setArr, item) => {
            obj[item[id]] ? '' : obj[item[id]] = true && setArr.push(item);
            return setArr;
        }, []);
        return arrays;
    },
    // 搜索-添加成员---清空
    searchCloseTag(){
      this.searchMenNames = [];
      this.currentSelectMember = []
      this.formInline.userIdList = []
      this.formInline.pageNum = 1
      // this.markLength = 0
      this.getCustomer()
    },
    //添加人弹窗确认回调
    clickSubmitTree(val){
      this.currentSelectMember = val.currentMember
      this.formInline.pageNum=1;
      this.formInline.userIdList = []
      this.searchMenNames = val.currentIdName
      val.sendArray.forEach(item => {
        this.formInline.userIdList.push(item.userId)
      })
      this.getCustomer()
      this.dialogVisibleTree = false;
    },
    selectTags(val){
      // console.log(val)
    }
  }
}
</script>
<style lang="scss" scoped> 
  .client-staff{
    .client-search{
      margin-bottom:10px;
      display: flex;
      align-items: center;
      /deep/.add-per-input{
        margin-right: 10px;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        cursor: pointer;
        .el-icon-close{
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 5px;
        }
      }
      .base-msg-input{
        width: 190px;
        margin-right: 10px;
      }
      .date-input{
        width:240px;
        margin-right:10px;
      }
      .add-per-input{
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .client-search .el-tag--plain{
      border-color: #DCDFE6;
      color: #C0C4CF;
    }
    .welcomeDia {
      .el-dialog__body{
        min-height: 200px;
        margin: 20px 20px;
        padding: 0px;
      }
      .el-dialog__footer{
        text-align: center;
      }
    }
    .treeDia{
      .el-dialog__body{
        min-height: 400px;
      } 
    }
    .custom-tree-node {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .span-line{
      width:1px;
      height:470px;
      background-color:#eee;
      display:inline-block;
      position: relative;
      left: 80%;
    }
    .select-right{
      display: flex;
      justify-content: space-between;
      padding:8px 9%;
      width: 80%;
      height: 20px;
      line-height: 20px;
      font-size: 16px;
      &:hover{
        background-color: #F0F7FF;
      }
    }
    .el-tag--plain{
      border-color: #606266;
      color: #606266;
    }
  }

</style>